let configureStore: any = null;
if (process.env.NODE_ENV === 'production') {
  configureStore = require('./configureStore.prod.tsx').default;
} else {
  configureStore = require('./configureStore.dev.tsx').default;
}
export default configureStore;
